import { defineStore } from "pinia";
import { adminLogin } from "../api/auth";
import { getToken, setToken, clearToken } from "../utils/token";

export const useAuthStore = defineStore("auth", {
    state: () => ({
        token: getToken()
    }),
    actions: {
        async login(username, password) {
            const res = await adminLogin({ username, password });
            const token = res?.data?.token || res?.data; // 兼容后端直接返回 token 字符串
            if (!token) throw new Error("登录响应未返回 token");
            this.token = token;
            setToken(token);
        },
        logout() {
            this.token = "";
            clearToken();
        }
    }
});
